import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { FormControlLabel, TextField } from "@mui/material";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { DeleteButton, List, useDataGrid } from "@refinedev/mui";
import React, { useState } from "react";

export const SymbolsList = () => {
  const { dataGridProps, setFilters, setCurrent, setPageSize } = useDataGrid({
    pagination: {
      pageSize: 10
    },
    sorters: {
      initial: [
        {
          field: "updated_at",
          order: "desc"
        }
      ]
    },
  });
  
  const formatDate = (timestamp: number) => {
    return new Date(timestamp * 1);
  };
  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "id",
        headerName: "Id",
        type: "number",
        minWidth: 50,
        hideable: false
      },
      {
        field: "symbol",
        headerName: "Symbol",
        minWidth: 50,
        hideable: false
      },
      {
        field: "prevSymbol",
        headerName: "PrevSymbol",
        minWidth: 50,
        hideable: false
      },
      {
        field: "type",
        headerName: "Type",
        minWidth: 50,
        hideable: false
      },
      {
        field: "company",
        headerName: "Company",
        minWidth: 200,
        hideable: false
      },
      {
        field: "source",
        headerName: "Source",
        minWidth: 100,
        hideable: false
      },
      {
        field: "op",
        headerName: "Op",
        minWidth: 100,
        hideable: false
      },
      {
        field: "comments",
        headerName: "Comments",
        minWidth: 100,
        hideable: false
      },
      {
        field: "created_at",
        headerName: "Created At",
        hideable: false,
        renderCell: function render({ row }) {
          return <>{formatDate(row.created_at).toLocaleString()}</>;
        },
        minWidth: 150,
      },
      {
        field: "updated_at",
        headerName: "Updated At",
        hideable: false,
        renderCell: function render({ row }) {
          return <>{formatDate(row.updated_at).toLocaleString()}</>;
        },
        minWidth: 150,
      },
      {
        field: "actions",
        headerName: "Actions",
        hideable: false,
        sortable: false,
        renderCell: function render({ row }) {
          return (
            <>
              <DeleteButton hideText recordItemId={row.id} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 80,
      },
    ],
    []
  );
  // search parts
  const [name, setName] = useState("");
  const handleFilter = () => {
    setCurrent(1);
    setPageSize(10);
    let searchArr: { field: string; value: string; operator: string }[] = [];
    if (name) {
      searchArr.push({
        field: "symbol[$ilike]",
        value: `%${name}%`,
        operator: "eq",
      });
    }
    setFilters(searchArr as any);
  };
  const clearFun = () => {
    setCurrent(1);
    setPageSize(10);
    setName("");
    setFilters([]);
  };
  return (
    <List>
      <FormControlLabel
        label=""
        style={{ width: "100%" }}
        control={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              width: "100%",
              marginLeft: "19px",
              marginBottom: "12px",
            }}
          >
            <div style={{ width: "90%", paddingBottom: "3px" }}>
              <TextField
                id="standard-basic"
                label="Name"
                variant="standard"
                value={name}
                onChange={(e) => setName(e.target.value)}
                fullWidth
              />
            </div>
            <div style={{ width: "60px" }}>
              <ClearOutlinedIcon onClick={clearFun} />
              <SearchIcon onClick={handleFilter} />
            </div>
          </div>
        }
      />
      <DataGrid {...dataGridProps} columns={columns} autoHeight paginationMode="server" rowsPerPageOptions={[10,20,50]} disableColumnFilter/>
    </List>
  );
};
